import {
  ScheduleEventCard,
  SpotlightScheduleEventSession,
} from 'interfaces/types'
import { createContext, Dispatch, SetStateAction } from 'react'

export enum ScheduleEventStatus {
  LIVED = 'lived',
  LIVE = 'live',
  COMMING_SOON = 'comming',
  NOT_YET = 'notyet',
  NEAREST_COMMING = 'nearest_comming',
}

export const DATE_FORMAT_API = 'YYYY-MM-DD HH:mm:ss'
export type ScheduleEventContextType = {
  changeToLivedEvent?: (item: ScheduleEventCard) => void
  changeToLiveEvent?: (item: ScheduleEventCard) => void
  openLeadModal: () => void
  campaign: any
  setCampaign: Dispatch<SetStateAction<any>>
  highlightEvent: ScheduleEventCard | null
  setHighlightEvent: Dispatch<SetStateAction<ScheduleEventCard | null>>
  applyH1?: boolean
} & SpotlightScheduleEventSession

export const ScheduleEventContext = createContext<ScheduleEventContextType>(
  {} as ScheduleEventContextType,
)
